import {
	TRAVEL_LOADING,
	TRAVEL_SAVING_FAILED,
	TRAVEL_SAVING_SUCCESSED,
} from "../actions/types";
const initialState = {
	data: {},
	saved: false,
};
export default function (state = initialState, action) {
	switch (action.type) {
		case TRAVEL_LOADING:
			return {
				...state,

				saved: false,
			};
		case TRAVEL_SAVING_SUCCESSED:
			return {
				...state,
				data: action.payload,
				saved: true,
			};
		case TRAVEL_SAVING_FAILED:
			return {
				...state,
				saved: false,
			};
		default:
			return state;
	}
}
